export const UserPhotoLeftStarsIcon = () => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="left-starts-icon"
    >
      <g clipPath="url(#clip0_15415_5114)">
        <path
          d="M24.8208 15.1761C19.4187 15.5019 15.0959 19.8249 14.7701 25.2269H14.7307C14.4049 19.8249 10.0821 15.5019 4.68018 15.1761V15.1367C10.0821 14.8109 14.4049 10.4881 14.7307 5.08594H14.7701C15.0959 10.4881 19.4187 14.8109 24.8208 15.1367V15.1761Z"
          fill="#EBBD46"
        />
      </g>
      <g clipPath="url(#clip1_15415_5114)">
        <path
          d="M10.9741 5.09587C8.27308 5.25876 6.11166 7.42026 5.94877 10.1212H5.92905C5.76616 7.42026 3.60475 5.25876 0.903809 5.09587V5.07615C3.60475 4.91326 5.76616 2.75184 5.92905 0.0507812H5.94877C6.11166 2.75184 8.27308 4.91326 10.9741 5.07615V5.09587Z"
          fill="#EBBD46"
        />
      </g>
      <defs>
        <clipPath id="clip0_15415_5114">
          <rect
            width="20.1409"
            height="20.1409"
            fill="white"
            transform="translate(4.68066 5.08594)"
          />
        </clipPath>
        <clipPath id="clip1_15415_5114">
          <rect
            width="10.0705"
            height="10.0705"
            fill="white"
            transform="translate(0.90332 0.0507812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
